<template>
  <div id="app">
    <iHeader/>
    <div class="con">
      <div class="w">
        <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >IMPORTANT NOTICE: THIS AGREEMENT IS SUBJECT TO BINDING ARBITRATION
          AND A WAIVER OF CLASS ACTION RIGHTS AS DETAILED IN SECTION 14. PLEASE
          READ THE AGREEMENT CAREFULLY.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >1. ACCEPTANCE OF TERMS</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">Wanchain Foundation</span
        ><span style="font-family:等线; font-size:11pt">'s </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt"> (“</span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt"
          >”) serves as a gateway to the decentralized internet by providing
          scalable access to the </span
        ><span style="font-family:等线; font-size:11pt">Wanchain</span
        ><span style="font-family:等线; font-size:11pt"> blockchain. </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          hosts a website that serves as a registration portal, product
          offering, and an overview of the health of </span
        ><span style="font-family:等线; font-size:11pt">i</span
        ><span style="font-family:等线; font-size:11pt">Wan</span
        ><span style="font-family:等线; font-size:11pt">
          services through our website located at: </span
        ><span style="color:#ff0000; font-family:等线; font-size:11pt"
          >https://</span
        ><span style="color:#ff0000; font-family:等线; font-size:11pt">i</span
        ><span style="color:#ff0000; font-family:等线; font-size:11pt">w</span
        ><span style="color:#ff0000; font-family:等线; font-size:11pt">an</span
        ><span style="color:#ff0000; font-family:等线; font-size:11pt">.</span
        ><span style="color:#ff0000; font-family:等线; font-size:11pt"
          >wanchain.org</span
        ><span style="color:#ff0000; font-family:等线; font-size:11pt">/ </span
        ><span style="font-family:等线; font-size:11pt"
          >(the "Site") which includes text, images, audio, code and other
          materials or </span
        ><span style="font-family:等线; font-size:11pt">third party</span
        ><span style="font-family:等线; font-size:11pt">
          information. The Site and any other features, tools, materials, or
          services offered from time to time by </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt"
          >, including our network infrastructure, is referred to here as the
          “Service.” Please read these Terms of Use (the “Terms” or “Terms of
          Use”) carefully before using the Service. By using or otherwise
          accessing the Services, or clicking to accept or agree to these Terms
          where that option is made available, you (1) accept and agree to these
          Terms (2) consent to the collection, use, disclosure and other
          handling of information as described in our Privacy Policy and (3) any
          additional terms, rules and conditions of participation issued by </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          from time to time. If you do not agree to the Terms, then you may not
          access or use the Services.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >2. MODIFICATION OF TERMS OF USE</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >Except for Section 14, providing for binding arbitration and waiver
          of class action rights, </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          reserves the right, at its sole discretion, to modify or replace the
          Terms of Use at any time. The most current version of these Terms will
          be posted on our Site. You shall be responsible for reviewing and
          becoming familiar with any such modifications. Use of the Services by
          you after any modification to the Terms constitutes your acceptance of
          the Terms of Use as modified.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">3. ELIGIBILITY</span>
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >You represent and warrant that you: (a) are of legal age to form a
          binding contract; (b) have not previously been suspended or removed
          from using our Services; and (c) have full power and authority to
          enter into this agreement and in doing so will not violate any other
          agreement to which you are a party. If you are registering to use the
          Services on behalf of a legal entity, you further represent and
          warrant that (</span
        ><span style="font-family:等线; font-size:11pt">i</span
        ><span style="font-family:等线; font-size:11pt"
          >) such legal entity is duly organized and validly existing under the
          applicable laws of the jurisdiction of its organization, and (ii) you
          are duly authorized by such legal entity to act on its behalf.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >4. ACCOUNT REGISTRATION</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >Usage or access to our services may require an account consisting of
          a User ID and/or a Password ("Account"). When you create an Account,
          you agree to: (a) create a strong password that you do not use for any
          other website or online service; (b) provide accurate and truthful
          information; (c) maintain and promptly update your Account
          information; (d) maintain the security of your Account by protecting
          your Account password and restricting access to your computer and your
          Account; (e) promptly notify us if you discover or otherwise suspect
          any security breaches related to your Account; and (f) take
          responsibility for all activities that occur under your Account and
          accept all risks of any authorized or unauthorized access to your
          Account, to the maximum extent permitted by law. When you create an
          Account, we assign you an account identifier that you must retain to
          access your Account.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >5. UNAUTHORIZED USE OR ACCESS</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >Unless otherwise expressly authorized in these Terms of Use or on the
          Website, you may not take any action to interfere with the Website or
          any other user’s use of the Website or decompile, reverse engineer or
          disassemble any Content or other products or processes accessible
          through the Website, nor insert any code or product or manipulate the
          Content in any way that affects any user’s experience. While using the
          Website you are required </span
        ><span style="font-family:等线; font-size:11pt"
          >to comply with all applicable statutes, orders, regulations, rules,
          and other laws. In addition, we expect users of the Website to respect
          the rights and dignity of others. Your use of the Website is
          conditioned on your compliance with the rules of conduct set forth in
          this section.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">&#xa0;</span>
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >You agree that you will neither use the Site in a manner, nor share
          any Content, that: (a) is false or misleading; (b) is defamatory,
          derogatory, degrading or harassing of another or constitutes a
          personal attack; (c) invades another's privacy or includes, copies or
          transmits another's confidential, sensitive or personal information;
          (d) promotes bigotry, racism, hatred or harm against any group or
          individual; (e) is obscene or not in good taste; (f) violates or
          infringes or promotes the violation or infringement of another's
          rights, including intellectual property rights; (g) you do not have
          the right and authority to share and grant the necessary rights and
          licenses for; (h) violates or promotes the violation of any applicable
          laws or regulations; (</span
        ><span style="font-family:等线; font-size:11pt">i</span
        ><span style="font-family:等线; font-size:11pt"
          >) contains a solicitation of funds, goods or services, or promotes or
          advertises goods or services; or (j) contains any viruses, Trojan
          horses, or other components designed to limit or harm the
          functionality of a computer.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >Additionally, you acknowledge and agree that you (and not </span
        ><span style="font-family:等线; font-size:11pt">Wanchain Fou</span
        ><span style="font-family:等线; font-size:11pt">n</span
        ><span style="font-family:等线; font-size:11pt">dation</span
        ><span style="font-family:等线; font-size:11pt"
          >) are responsible for obtaining and maintaining all
          telecommunications, broadband, and computer hardware, equipment, and
          services needed to access and use the Website, and paying all charges
          related thereto.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">&#xa0;</span>
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >6. REPRESENTATIONS, WARRANTIES AND RISKS</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >6.1. Warranty disclaimer</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >You expressly understand and agree that your use of the Service is at
          your sole risk. The Service is provided on an "AS IS" and "as
          available" basis, without warranties of any kind, either express or
          implied, including, without limitation, implied warranties of
          merchantability, fitness for a particular purpose or non-infringement.
          You release </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          from all liability for content you acquired or failed to acquire
          through the Service.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >6.2 Sophistication and Risk of Cryptographic Systems</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >By utilizing the Service or platform in any way, you represent that
          you understand the inherent risks associated with cryptographic
          systems; and warrant that you have an understanding of the usage and
          intricacies of public/private key cryptography, native cryptographic
          tokens, like</span
        ><span style="font-family:等线; font-size:11pt"> Wan (WAN),</span
        ><span style="font-family:等线; font-size:11pt">
          Ether (ETH) and Bitcoin (BTC), smart </span
        ><span style="font-family:等线; font-size:11pt">contract based</span
        ><span style="font-family:等线; font-size:11pt"> tokens such as</span
        ><span style="font-family:等线; font-size:11pt">
          WRC20 and ERC20 tokens</span
        ><span style="font-family:等线; font-size:11pt"
          >, and blockchain-based software systems.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >6.3 Platform Security</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          is an early stage platform. You acknowledge that </span
        ><span style="font-family:等线; font-size:11pt">Wanchain</span
        ><span style="font-family:等线; font-size:11pt">
          applications are code subject to flaws and acknowledge that you are
          solely responsible for evaluating any available code provided by the
          Services. You further expressly acknowledge and represent that </span
        ><span style="font-family:等线; font-size:11pt">Wanchain</span
        ><span style="font-family:等线; font-size:11pt">
          applications can be written maliciously or negligently, that </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          cannot be held liable for your interaction with such applications and
          that such applications may cause loss of property or identity. These
          warnings and others later provided by </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          in no way evidence or represent an on-going duty to alert you to all
          of the potential risks of utilizing the Service or Content.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">7. INDEMNITY</span>
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >You agree, to the fullest extent permitted by applicable law, to
          release and to indemnify, defend and hold harmless </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          and its parents, subsidiaries, affiliates and agencies, as well as the
          officers, directors, employees, shareholders and representatives of
          any of the foregoing entities, from and against any and all losses,
          liabilities, expenses, damages, costs (including attorneys’ fees and
          court costs) claims or actions of any kind whatsoever arising or
          resulting from your use of the Service, your violation of these Terms
          of Use, and any of your acts or </span
        ><span style="font-family:等线; font-size:11pt"
          >omissions that implicate publicity rights, defamation or invasion of
          privacy. </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          reserves the right, at its own expense, to assume exclusive defense
          and control of any matter otherwise subject to indemnification by you
          and, in such case, you agree to cooperate with </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          in the defense of such matter.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >8. LIMITATION ON LIABILITY</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >YOU ACKNOWLEDGE AND AGREE THAT YOU ASSUME FULL RESPONSIBILITY FOR
          YOUR USE OF THE SITES AND SERVICE. YOU ACKNOWLEDGE AND AGREE THAT ANY
          INFORMATION YOU SEND OR RECEIVE DURING YOUR USE OF THE SITES AND
          SERVICE MAY NOT BE SECURE AND MAY BE INTERCEPTED OR LATER ACQUIRED BY
          UNAUTHORIZED PARTIES. YOU ACKNOWLEDGE AND AGREE THAT YOUR USE OF THE
          SITES AND SERVICE IS AT YOUR OWN RISK. RECOGNIZING SUCH, YOU
          UNDERSTAND AND AGREE THAT, TO THE FULLEST EXTENT PERMITTED BY
          APPLICABLE LAW, NEITHER </span
        ><span style="font-family:等线; font-size:11pt">IWAN</span
        ><span style="font-family:等线; font-size:11pt">
          NOR ITS SUPPLIERS OR LICENSORS WILL BE LIABLE TO YOU FOR ANY DIRECT,
          INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, EXEMPLARY OR
          OTHER DAMAGES OF ANY KIND, INCLUDING WITHOUT LIMITATION DAMAGES FOR
          LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER TANGIBLE OR INTANGIBLE
          LOSSES OR ANY OTHER DAMAGES BASED ON CONTRACT, TORT (INCLUDING, IN
          JURISDICTIONS WHERE PERMITTED, NEGLIGENCE AND GROSS NEGLIGENCE),
          STRICT LIABILITY OR ANY OTHER THEORY (EVEN IF </span
        ><span style="font-family:等线; font-size:11pt">IWAN</span
        ><span style="font-family:等线; font-size:11pt">
          HAD BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM
          THE SITE OR SERVICE; THE USE OR THE INABILITY TO USE THE SITES OR
          SERVICE; UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR
          DATA; STATEMENTS OR CONDUCT OF ANY THIRD PARTY ON THE SITES OR
          SERVICE; ANY ACTIONS WE TAKE OR FAIL TO TAKE AS A RESULT OF
          COMMUNICATIONS YOU SEND TO US; HUMAN ERRORS; TECHNICAL MALFUNCTIONS;
          FAILURES, INCLUDING PUBLIC UTILITY OR TELEPHONE OUTAGES; OMISSIONS,
          INTERRUPTIONS, LATENCY, DELETIONS OR DEFECTS OF ANY DEVICE OR NETWORK,
          PROVIDERS, OR SOFTWARE (INCLUDING, BUT NOT LIMITED TO, THOSE THAT DO
          NOT PERMIT PARTICIPATION IN THE SERVICE); ANY INJURY OR DAMAGE TO
          COMPUTER EQUIPMENT; INABILITY TO FULLY ACCESS THE SITES OR SERVICE OR
          ANY OTHER WEBSITE; THEFT, TAMPERING, DESTRUCTION, OR UNAUTHORIZED
          ACCESS TO, IMAGES OR OTHER CONTENT OF ANY KIND; DATA THAT IS PROCESSED
          LATE OR INCORRECTLY OR IS INCOMPLETE OR LOST; TYPOGRAPHICAL, PRINTING
          OR OTHER ERRORS, OR ANY COMBINATION THEREOF; OR ANY OTHER MATTER
          RELATING TO THE SITES OR SERVICE. SOME JURISDICTIONS DO NOT ALLOW THE
          EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF
          LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME
          OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">9. LICENSE</span>
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >Subject to your compliance with these Terms of Use, </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          grants you a limited, non-exclusive, non-transferable,
          non-sublicensable license to access and make personal and
          non-commercial use of the Service. This license does not include any
          resale or commercial use of the Service or any derivative use of the
          Service. All rights not expressly granted to you in these Terms of Use
          are reserved and retained by </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          or its licensors. The </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          Service may not be reproduced, duplicated, copied, sold, resold,
          visited, or otherwise exploited for any commercial purpose without
          express written consent of </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt"
          >. You may not frame or utilize framing techniques to enclose any
          trademark, logo, or other proprietary information (including images,
          text, page layout, or form) of </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          without express written consent. You may not misuse the Services. You
          may use the Services only as permitted by law. The licenses granted by </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          terminate if you do not comply with these Terms of Use.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >10. DISCONTINUANCE OF SERVICES</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >We may, in our sole discretion and without liability to you, with or
          without prior notice and at any time, modify or discontinue,
          temporarily or permanently, any portion of our Services.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >11. TERMINATION AND SUSPENSION</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          may terminate or suspend all or part of the Service without prior
          notice or liability if you breach any of the terms or conditions of
          the Terms. The following provisions of the Terms survive any
          termination of these Terms: INDEMNITY; WARRANTY DISCLAIMERS;
          LIMITATION ON LIABILITY; OUR PROPRIETARY RIGHTS; TERMINATION; NO </span
        ><span style="font-family:等线; font-size:11pt">THIRD PARTY</span
        ><span style="font-family:等线; font-size:11pt">
          BENEFICIARIES; BINDING ARBITRATION AND CLASS ACTION WAIVER; GENERAL
          INFORMATION.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >12. NO THIRD PARTY BENEFICIARIES</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >You agree that, except as otherwise expressly provided in these
          Terms, there shall be no </span
        ><span style="font-family:等线; font-size:11pt">third party</span
        ><span style="font-family:等线; font-size:11pt">
          beneficiaries to the Terms.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >13. NOTICE AND PROCEDURE FOR MAKING CLAIMS OF COPYRIGHT
          INFRINGEMENT</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >If you believe that your copyright or the copyright of a person on
          whose behalf you are authorized to act has been infringed, please
          provide </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">'s</span
        ><span style="font-family:等线; font-size:11pt">
          Copyright Agent a written notice containing the following
          information:</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >an electronic or physical signature of the person authorized to act
          on behalf of the owner of the copyright or other intellectual property
          interest;</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >a description of the copyrighted work or other intellectual property
          that you claim has been infringed;</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >a description of where the material that you claim is infringing is
          located on the Service;</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >your address, telephone number, and email address;</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >a statement by you that you have a good faith belief that the
          disputed use is not authorized by the copyright owner, its agent, or
          the law;</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >a statement by you, made under penalty of perjury, that the above
          information in your Notice is accurate and that you are the copyright
          or intellectual property owner or authorized to act on the copyright
          or intellectual property owner's behalf.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">'s</span
        ><span style="font-family:等线; font-size:11pt">
          Copyright Agent can be reached at:</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">Email: </span
        ><span style="font-family:等线; font-size:11pt">info@wanchain.org</span
        ><span style="font-family:等线; font-size:11pt"> </span>
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">Subject Line: </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt"> </span
        ><span style="font-family:等线; font-size:11pt"
          >Copyright Notification Mail</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >11. BINDING ARBITRATION AND CLASS ACTION WAIVER</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >PLEASE READ THIS SECTION CAREFULLY – IT MAY SIGNIFICANTLY AFFECT YOUR
          LEGAL RIGHTS, INCLUDING YOUR RIGHT TO FILE A LAWSUIT IN COURT</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >13.1 Initial Dispute Resolution</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >The parties shall use their best efforts to engage directly to settle
          any dispute, claim, question, or disagreement and engage in good faith
          negotiations which shall be a condition to either party initiating a
          lawsuit or arbitration.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >13.2 Binding Arbitration</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >If the parties do not reach an agreed upon solution within a period
          of 30 days from the time informal dispute resolution under the Initial
          Dispute Resolution provision begins, then either party may initiate
          binding arbitration as the sole means to resolve claims, subject to
          the terms set forth below. Specifically, all claims arising out of or
          relating to these Terms (including their formation, performance and
          breach), the parties’ relationship with each other and/or your use of
          the Service shall be finally settled by binding arbitration
          administered by the </span
        ><span style="font-family:等线; font-size:11pt"
          >Singapore International Arbitration Centre</span
        ><span style="font-family:等线; font-size:11pt">
          in accordance with the provisions of its Commercial Arbitration Rules
          and the supplementary procedures for consumer related disputes of the </span
        ><span style="font-family:等线; font-size:11pt"
          >Singapore International Arbitration Centre</span
        ><span style="font-family:等线; font-size:11pt">, </span
        ><span style="font-family:等线; font-size:11pt"
          >excluding any rules or procedures governing or permitting class
          actions. The arbitrator, and not any</span
        ><span style="font-family:等线; font-size:11pt"> </span
        ><span style="font-family:等线; font-size:11pt"
          >court or agency, shall have exclusive authority to resolve all
          disputes arising out of or relating to the interpretation,
          applicability, enforceability or formation of these Terms, including,
          but not limited to any claim that all or any part of these Terms are
          void or voidable, or whether a claim is subject to arbitration. The
          arbitrator shall be empowered to grant whatever relief would be
          available in a court under law or in equity. The arbitrator’s award
          shall be written, and binding on the parties and may be entered as a
          judgment in any court of competent jurisdiction. The parties
          understand that, absent this mandatory provision, they would have the
          right to sue in court and have a jury trial. They further understand
          that, in some instances, the costs of arbitration could exceed the
          costs of litigation and the right to discovery may be more limited in
          arbitration than in court.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">13.3 Location</span>
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >Binding arbitration shall take place in </span
        ><span style="font-family:等线; font-size:11pt">Singapore</span
        ><span style="font-family:等线; font-size:11pt"
          >. You agree to submit to the personal jurisdiction of court in </span
        ><span style="font-family:等线; font-size:11pt">Singapore</span
        ><span style="font-family:等线; font-size:11pt"
          >, in order to compel arbitration, to stay proceedings pending
          arbitration, or to confirm, modify, vacate or enter judgment on the
          award entered by the arbitrator.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >13.4 Class Action Waiver</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >The parties further agree that any arbitration or other permitted
          action shall be conducted in their individual capacities only and not
          as a class action or other representative action, and the parties
          expressly waive their right to file a class action or seek relief on a
          class basis. YOU AND </span
        ><span style="font-family:等线; font-size:11pt">IWAN</span
        ><span style="font-family:等线; font-size:11pt">
          AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS
          INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY
          PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. If any court or
          arbitrator determines that the class action waiver set forth in this
          paragraph is void or unenforceable for any reason or that an
          arbitration can proceed on a class basis, then the arbitration
          provision set forth above shall be deemed null and void in its
          entirety and the parties shall be deemed to have not agreed to
          arbitrate disputes.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >13.5 Exception - Litigation of Intellectual Property and Small Claims
          Court Claims</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >Notwithstanding the parties' decision to resolve all disputes through
          arbitration, either party may bring an action in court to protect its
          intellectual property rights (“intellectual property rights” means
          patents, copyrights, moral rights, trademarks, and trade secrets, but
          not privacy or publicity rights). Either party may also seek relief in
          a small claims court for disputes or claims within the scope of that
          court’s jurisdiction.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >13.6 30-Day Right to </span
        ><span style="font-family:等线; font-size:11pt">Opt</span
        ><span style="font-family:等线; font-size:11pt"> Out</span>
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >You have the right to opt-out and not be bound by the arbitration and
          class action waiver provisions set forth above by sending written
          notice of your decision to opt-out via email at </span
        ><span style="font-family:等线; font-size:11pt">info</span
        ><span style="font-family:等线; font-size:11pt">@</span
        ><span style="font-family:等线; font-size:11pt">wanchain</span
        ><span style="font-family:等线; font-size:11pt">.</span
        ><span style="font-family:等线; font-size:11pt">org</span
        ><span style="font-family:等线; font-size:11pt"
          >, with subject line </span
        ><span style="font-family:等线; font-size:11pt">IWAN</span
        ><span style="font-family:等线; font-size:11pt">
          LEGAL OPT OUT. The notice must be sent within 30 days of your first
          use of the Service, whichever is later, otherwise you shall be bound
          to arbitrate disputes in accordance with the terms of those
          paragraphs. If you opt-out of these arbitration provisions, </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          also will not be bound by them.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >13.7 Changes to this Section</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          will provide 60-days’ notice of any changes to this section. Changes
          will become effective on the 60th day, and will apply prospectively
          only to any claims arising after the 60th day. For any dispute not
          subject to arbitration you and </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          agree to submit to the personal and exclusive jurisdiction of and
          venue in courts located in </span
        ><span style="font-family:等线; font-size:11pt">Singapore.</span
        ><span style="font-family:等线; font-size:11pt">
          You further agree to accept service of process by mail, and hereby
          waive any and all jurisdictional and venue defenses otherwise
          available. The Terms and the relationship between you and </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          shall be governed by the laws of </span
        ><span style="font-family:等线; font-size:11pt">Singapore</span
        ><span style="font-family:等线; font-size:11pt">
          without regard to conflict of law provisions.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >14. GENERAL INFORMATION</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >14.1 Entire Agreement</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >These Terms (and any additional terms, rules and conditions of
          participation that </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          may post on the Service) constitute the entire agreement between you
          and </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          with respect to the Service and supersedes any prior agreements, oral
          or written, between you and </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt"
          >. In the event of a conflict between these Terms and the additional
          terms, rules and conditions of participation, the latter will prevail
          over the Terms to the extent of the conflict.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >14.2 Waiver and Severability of Terms</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt">The failure of </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          to exercise or enforce any right or provision of the Terms shall not
          constitute a waiver of such right or provision. If any provision of
          the Terms is found by an arbitrator or court of competent jurisdiction
          to be invalid, the parties nevertheless agree that the arbitrator or
          court should endeavor to give effect to the parties' intentions as
          reflected in the provision, and the other provisions of the Terms
          remain in full force and effect.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >14.3 Statute of Limitations</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >You agree that regardless of any statute or law to the contrary, any
          claim or cause of action arising out of or related to the use of the
          Service or the Terms must be filed within one (1) year after such
          claim or cause of action arose or be forever barred.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >14.4 Section Titles</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >The section titles in the Terms are for convenience only and have no
          legal or contractual effect.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >14.5 Communications</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >Users with questions, complaints or claims with respect to the
          Service may contact us using the relevant contact information set
          forth above.</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >15. SOFTWARE LICENSE</span
        >
      </p>
      <p
        style="font-size:11pt; line-height:108%; margin:0pt 0pt 8pt; orphans:0; text-align:justify; widows:0"
      >
        <span style="font-family:等线; font-size:11pt"
          >All Rights Reserved. </span
        ><span style="font-family:等线; font-size:11pt">iWan</span
        ><span style="font-family:等线; font-size:11pt">
          is currently exploring the appropriate license structure and this will
          be updated when a conclusion is reached.</span
        >
      </p>
      </div>
    </div>
    <iFooter/>
  </div>
</template>
<script>
import iHeader from "../../components/Header/Header";
import iFooter from "../../components/Footer/Footer";

export default {
  components: {
    iHeader,
    iFooter
  }
};
</script>

<style lang="scss">
.con {
  width: 100%;
  padding: 120px 0;
  background: #ffff;
  .w {
    width: 70%;
    margin: 0 15%;
  }
}
</style>


// WEBPACK FOOTER //
// Terms.vue?f6867a06